<template>
  <div>
    <LayoutTitle :title="item.groupName" v-for="(item, index) in dynamicList" :key="item.groupId">
      <FormLayout
        ref="projectForm" 
        :readOnly="readOnly"
        :model="teamInfo"
        :list="generatePage(index)"
         @on-change-diff="checkPerson"
         @on-blur="handleInputBlur"
        @on-change-all="person">
      </FormLayout>
    </LayoutTitle>
    <LayoutTitle title="近三年获得荣誉" :showBtn="!readOnly" btnText="新增荣誉" @on-click="addHonor" v-if="show">
      <DragTable
        class="iv-m-t-24"
        noSearch 
        :showSelect="false"
        :showEdit="!readOnly"
        :showDelete="!readOnly"
        ref="DragTable"
        :showPage="false"
        :immediateForce="true" 
        :columns="honorColumn" 
        :tableData="honorData">
      </DragTable>
    </LayoutTitle>
    <LayoutTitle title="团队成员" :showBtn="!readOnly" btnText="添加成员" @on-click="addMember" v-if="show">
      <DragTable
        class="iv-m-t-24 iv-p-b-40"
        noUrl
        noSearch 
        :showSelect="false" 
        ref="DragTable1"
        :showDelete="!readOnly"
        :showPage="false"
        :showEdit="false"
        :immediateForce="true"
        :columns="memberColumn" 
        :tableData="memberData">
      </DragTable>
    </LayoutTitle>
    <SelectMember :treeType="treeType" ref="SelectMember" :hideSelectInput="true" v-model="memberData" :listProps="listProps" @on-change-all="selectPerson"></SelectMember>
  </div>
</template>

<script>
import {timeFormat} from '@/utils'
import { cloneDeep } from 'lodash'
import honorColumn from './honorColumn.js'
import memberColumn from './memberColumn.js'
import generateList from './generate-form'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import LayoutTitle from '@/components/layout/layout-title'
import SelectMember from '@/components/select-input-member'
import { submitGroupSignUp, getGroupSignUp, editGroupSignUp } from '../../interface'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      teamInfo: {},
      honorData: [],
      memberData: [],
      groupId: '',
      formLayout: [],
      show: true,
      dynamicList: [],
      treeType: {}
    }
  },
  created () {
    const idMap = JSON.parse(sessionStorage.getItem('idMap'))
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    this.orgId = this.$decode(sessionStorage.getItem(idMap[this.bizLineCode]))
    this.treeType = {
      type: 'single-organize-life'
    }
    this.listProps = {
      async: true,
      type: 'checkbox',
      isAllResult: true,
      selectUserSwitch: true,
      bizLineCode: this.bizLineCode,
      listUrl: '/api-general/module/portal/user/listOrganizationUser',
      treeData: {
        orgId: this.orgId,
        scope: 2
      }
    }
    this.readOnly = this.$decode(this.$route.query.type) == 'see'
    //  0701需求要求工会时要放开荣誉列表、成员列表
    // if (this.bizLineCode === 'YWX03') {
    //   this.show = false  
    // } else {
    //   this.honorColumn = honorColumn.call(this)
    //   this.memberColumn = memberColumn.call(this)
    // }
    this.honorColumn = honorColumn.call(this)
    this.memberColumn = memberColumn.call(this)
  },
  provide () {
    return {
      saveItem: this.saveItem,
      deleteItem: this.deleteItem,
      removeAdd: this.removeAdd
    }
  },
  inject: ['getApplicationObjectId'],
  methods: {
    handleInputBlur (val, data) {
      if(val.key == 'teamMemberNum') {
        this.$set(this.teamInfo, 'teamMemberNum', data)
      } else if(val.key == 'teamWomenNum') {
        this.$set(this.teamInfo, 'teamWomenNum', data)
      }
      if(this.teamInfo.teamMemberNum && this.teamInfo.teamWomenNum) {
        this.getWomen()
      }
    },
    getWomen () {
      let number = (this.teamInfo.teamWomenNum / this.teamInfo.teamMemberNum).toFixed(2) * 100 + '%'
      this.$set(this.teamInfo, 'teamWomenRatio', number)
    },
    //生成表单和表格
    generatePage (index) {
      return generateList.call(this, index)
    },
    //重置表单校验
    resetFields () {
      this.$nextTick(() => {
        if (Array.isArray(this.$refs.projectForm)) {
          this.$refs.projectForm.every(ref => {
            ref.resetFields()
          })
        } else {
          this.$refs.projectForm.resetFields()
        }
      })
    },
    //转换对应的值
    transferDataType () {
      if (!this.dynamicList.length) return
      this.dynamicList.forEach((item) => {
        item.formPropertyList.forEach(val => {
          const value = this.teamInfo[val.propertyCode]
          if (val.widgetType == 'InputNumber') {
            this.$set(this.teamInfo, val.propertyCode, value ?? null)
          }
          if (val.widgetType == 'DatePicker') {
            this.$set(this.teamInfo, val.propertyCode, value ? timeFormat(value) : '')
          }
        })
      })
    },
    //获取详情
    getPersonInfo (params) {
      this.teamInfo = {}
      if (params) {
        // this.readOnly = !params.isReportState
        this.teamInfo.companyWomenNum = null
        this.teamInfo.teamMemberNum = null
        this.teamInfo.memberAvgAge = null
        this.teamInfo.teamWomenNum = null
        this.teamInfo.teamWomenRatio = null
        this.teamInfo.teamWomenLeaderNum = null
        getGroupSignUp({signUpId: params.signUpId, orgId: params.orgId}).then(({data}) => {
          if (params.quickFill) {
            data.isCancel = '0'
          }
          //把特殊字符& 转义, 查询回来之后再替换回去
          data.contributionsAndResults = data.contributionsAndResults || ''
          data.mainDeeds = data.mainDeeds || ''
          data.deedsIntroduction = data.deedsIntroduction || ''
          data.contributionsAndResults = data.contributionsAndResults.replace(/%26/g, '&')
          data.mainDeeds = data.mainDeeds.replace(/%26/g, '&')
          data.deedsIntroduction = data.deedsIntroduction.replace(/%26/g, '&')
          let isCancel = data.isCancel
          this.readOnly = isCancel == '1'
          this.teamInfo = { ...this.teamInfo, ...data }
          this.teamInfo.teamLeaderName = [{
            userId: this.teamInfo.teamLeaderId || '',
            userName: this.teamInfo.teamLeaderName
          }]
          this.teamInfo.teamWomenRatio = this.teamInfo.teamWomenRatio ? this.teamInfo.teamWomenRatio + '%' : ''
          this.honorData = data.rewardsList.map(item => ({
            ...item,
            $type: 'honor',
            rewardDate: timeFormat(item.rewardDate)
          }))
          this.memberData = data.teamMemberList ? data.teamMemberList.map(item => ({
            ...item,
            $type: 'member',
            userId: item.memberUserId,
            userName: item.memberUserName
          })) : []
          //设置附件
          if (this.teamInfo.attachmentGroupId) {
            this.groupId = this.teamInfo.attachmentGroupId
            this.getActivityFiles(this.groupId).then(data => {
              this.$set(this.teamInfo, 'uploadFile', data)
              console.log(this.teamInfo, 'this.teamInfo')
            })
          } else {
            this.groupId = this.getUuid()
          }
          this.$emit('on-request', {
            ...data,
            isCancel: isCancel
          })
          //动态表单
          this.dynamicList = this.list
          this.transferDataType()
        })
      } else {
        this.readOnly = false
        this.groupId = this.getUuid()
        //动态表单
        this.dynamicList = this.list
        this.transferDataType()
      }
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    //选择负责人
    person ([item], key) {
      if(key == 'teamLeaderName') {
        this.$set(this.teamInfo, 'memberUsercode', item.userCode)
        this.$set(this.teamInfo, 'teamLeaderContact', item.phone)
      }
    },
    judgeRefs () {
      let refs = this.$refs.projectForm
      if (!Array.isArray(refs)) {
        refs = [this.$refs.projectForm]
      }
      const req = refs.map(ref => ref.validateify())
      return req
    },
    //将date对象格式化
    dateFormat (obj) {
      Object.keys(obj).forEach(item => {
        if (obj[item] instanceof Date) {
          obj[item] = timeFormat(obj[item])
        }
      })
      return obj
    },
    //提交
    submitPersonInfo (recommendInfo) {
      const applicationObjectId = this.getApplicationObjectId()
      Promise.all(this.judgeRefs()).then(res => {
        const result = res.every(v => v)
        if (!result) {
          this.$emit('on-close', 'valid')
          this.$Message.error('表单校验失败')
          return
        }
        const isContinue = this.validateTable()
        if (!isContinue) {
          this.$emit('on-close', 'valid')
          return
        }
        const requestMethod = recommendInfo.signUpId ? editGroupSignUp : submitGroupSignUp
        //把特殊字符& 转义, 查询回来之后再替换回去
        const arr = cloneDeep(this.teamInfo)
        arr.contributionsAndResults = arr.contributionsAndResults || ''
        arr.mainDeeds = arr.mainDeeds || ''
        arr.deedsIntroduction = arr.deedsIntroduction || ''
        arr.contributionsAndResults = arr.contributionsAndResults.replace(/&/g, encodeURIComponent('&')) || ''
        arr.mainDeeds = arr.mainDeeds.replace(/&/g, encodeURIComponent('&')) || ''
        arr.deedsIntroduction = arr.deedsIntroduction.replace(/&/g, encodeURIComponent('&')) || ''
        let teamWomenRatio = 0
        if (arr.teamWomenRatio) {
          teamWomenRatio = arr.teamWomenRatio.substring(0, arr.teamWomenRatio.length - 1)
        }
        const params = this.dateFormat({
          ...recommendInfo,
          ...arr,
          teamLeaderId: this.teamInfo.teamLeaderName[0].userId,
          teamLeaderName: this.teamInfo.teamLeaderName[0].userName,
          attachmentGroupId: this.groupId,
          applicationObjectId: applicationObjectId,
          teamWomenRatio: teamWomenRatio
        })
        if (this.honorData.length) {
          params.rewardsList = this.honorData.map(val => {
            const newItem = cloneDeep(val)
            if (Object.keys(newItem).includes('$type')) {
              delete newItem.$type
            }
            return newItem
          })
        } else if (!this.honorData.length && params.rewardsList) {
          delete params.rewardsList
        }
        if (this.memberData.length) {
          params.teamMemberList = this.memberData.map(val => {
            const newItem = cloneDeep(val)
            if (Object.keys(newItem).includes('$type')) {
              delete newItem.$type
            }
            return newItem
          })
        } else if (!this.memberData.length && params.teamMemberList) {
          delete params.teamMemberList
        }
        requestMethod(params, {
          headers: {
            'Content-Type': 'application/json'
          },
          disabledData: true
        }).then(({data}) => {
          this.$Message.success('提交成功')
          if (!recommendInfo.signUpId) {
            let type = 'addType' //修改
            this.$emit('on-request', {
              ...recommendInfo,
              signUpId: data.signUpId
            }, type) //修改
          } else {
            this.$emit('on-close')
          }
        }).catch(() => {
          this.$emit('on-close', 'valid')
        })
      })
    },
    validateTable () {
      let isContinue = true
      if (this.honorData.length) {
        isContinue = this.honorData.every(item => !item.errorQueue)
        if (!isContinue) {
          this.$Message.warning('荣誉记录必填项未填写')
          return isContinue
        }
      }
      return isContinue
    },
    //点击取消
    removeAdd (index, item) {
      if (item._add) {
        const data = item.$type == 'honor' ? 'honorData' : 'memberData'
        this[data].splice(index, 1)
      } else {
        for (let i in item) {
          if (Object.prototype.toString.call(item[i]) === '[object Date]') {
            item[i] = timeFormat(item[i])
          }
        }
      }
    },
    //表格校验
    validateColumns (item) {
      let isContinue = true
      item.errorQueue = item.errorQueue || {}
      Object.keys(item).forEach(val => {
        if (val == 'isEdit' || val.indexOf('_') != -1) {
          item.errorQueue[val] = false
        } else if (!item[val]) {
          item.errorQueue[val] = true
          isContinue = false
        } else {
          item.errorQueue[val] = false
        }
      })
      return isContinue
    },
    //保存
    saveItem (item) {
      const index = item._index
      const isContinue = this.validateColumns(item)
      if (!isContinue) {
        this.$set(this.honorData, index, item)
        return Promise.reject(item)
      } else {
        for (let i in item) {
          if (Object.prototype.toString.call(item[i]) === '[object Date]') {
            item[i] = timeFormat(item[i])
          }
          if (i.indexOf('_') != -1) {
            delete item[i]
          }
        }
        delete item.errorQueue
        item.isEdit = false
        this.honorData.splice(index, 1, item)
        return Promise.resolve({item, showMessage: 'message'})
      }
    },
    //删除
    deleteItem (item) {
      if (item.$type == 'honor') {
        this.honorData.splice(item._index, 1)
      }
      if (item.$type == 'member') {
        this.memberData.splice(item._index, 1)
      }
      return Promise.resolve(item)
    },
    //选择工会、单位
    checkPerson (data, key, column, model) {
      if (column.key == 'orgName') {
        this.teamInfo.orgId = data[0].id
      }
      this.$set(this.teamInfo, 'teamLeaderContact', data?.data?.item?.phone || '')
      this.$set(this.teamInfo, 'fuzerengonghao', data?.data?.item?.userCode || '')
    },
    //选人弹框
    selectPerson (list) {
      const userIds = this.memberData.map(val => val.memberUserId)
      list.forEach(val => {
        if (!userIds.includes(val.userId) && !userIds.includes(val.memberUserId)) {
          this.memberData.push({
            memberUserName: val.userName,
            employeeNumber: val.userCode,
            memberUserId: val.userId,
            $type: 'member'
          })
        }
      })
    },
    //新增荣誉
    addHonor () {
      this.honorData.unshift({
        isEdit: true,
        $type: 'honor',
        errorQueue: {},
        rewardDate: '',
        awardOrganization: '',
        rewardTitle: '',
        _add: true
      })
    },
    //新增人员
    addMember () {
      this.$methods('SelectMember', 'onShowTree')
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  },
  components: {
    DragTable,
    FormLayout,
    LayoutTitle,
    SelectMember
  }
}
</script>
